import React, { useState, useCallback } from 'react';
import block from 'bem-cn';
import dayjs from 'dayjs';
import { useSelector, useDispatch } from 'react-redux';

import Select from 'components/Select/desktop';
import Button from 'components/Button';
import DateInput from 'components/DateInput';

import DaysFilter from '../../../../DaysFilter';

import { structure } from '../../../../../data';

import { actions } from 'features/reports/redux';

import './FilterBlock.scss';

const b = block('filter-block');

const FilterBlock = ({ isMobile }) => {
  const locale = useSelector(state => state.locale.locale);
  const dispatch = useDispatch();
  const [date, setDate] = useState({
    beginDate: new Date(dayjs().add(-1, 'day')),
    endDate: new Date(dayjs()),
  });
  const [activeDay, setActiveDay] = useState('');

  const [filters, setFilters] = useState({
    structure: structure[0],
  });

  const onChangeBeginDate = value => {
    if (!isNaN(value.valueOf())) {
      setDate({ ...date, beginDate: value });
    }

    setActiveDay('');
  };

  const onChangeEndDate = value => {
    if (!isNaN(value.valueOf())) {
      setDate({ ...date, endDate: value });
    }
  };

  const handleStructureChange = value => {
    const structureItem = structure.find(item => item.value === value);
    setFilters({ ...filters, structure: structureItem });
  };

  const handleSearch = () => {
    dispatch(actions.getStatisticProvider({ ...date, ...filters }));
  };

  const onChangeActiveDay = useCallback(dayFilter => {
    setActiveDay(dayFilter);
    setDate({ ...date, beginDate: new Date(dayjs().add(dayFilter.value, 'day')) });
  }, []);

  return (
    <div className={b({ isMobile })}>
      <DaysFilter activeDay={activeDay} setActiveDay={onChangeActiveDay} isMobile={isMobile} />
      <div className={b('wrapper')}>
        <div className={b('filter-row')}>
          <DateInput
            name="dateFrom"
            text="dateFrom"
            size="middle"
            rounded
            format="dd/MM/yyyy"
            value={date.beginDate}
            onChange={onChangeBeginDate}
          />
        </div>
        <div className={b('filter-row')}>
          <DateInput
            name="dateUntil"
            text="dateUntil"
            size="middle"
            rounded
            format="dd/MM/yyyy"
            value={date.endDate}
            onChange={onChangeEndDate}
          />
        </div>

        <div className={b('filter-row')}>
          <p className={b('filter-row', 'title')}>{locale.show}:</p>
          <Select name="structure" items={structure} activeItem={filters.structure} onChange={handleStructureChange} />
        </div>
        <div className={b('search-btn')}>
          <Button callBack={() => handleSearch()} text={locale.search} search upperCased={isMobile} />
        </div>
      </div>
    </div>
  );
};

export default FilterBlock;
